import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectActiveLocalUnits } from 'sp-mark/feature-modules/boot/redux';
import * as bootActions from 'sp-mark/feature-modules/boot/redux/boot.actions';
import { selectRoutingLog } from 'sp-mark/redux/router';
import * as routingActions from 'sp-mark/redux/router/router.actions';
import { closeDialog, openDialog } from 'sp-ui-lib';

@Injectable({
  providedIn: 'root'
})
export class SingleUnitsGuardService implements CanActivate {
  constructor(private appState$: Store, private router: Router) {
    this.appState$.select(selectActiveLocalUnits).subscribe(units => this.selectedUnits = units ? units.length : 0);
    this.appState$.select(selectRoutingLog).subscribe(log => this.routingLog = [...log]);
  }

  selectedUnits = 0;
  routingLog: Array<{ path: string; id: string }> = [];

  // tslint:disable-next-line: naming-conventions
  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.selectedUnits === 1) {
      this.appState$.dispatch(bootActions.toggleLocalUnitsDisable({ flagLocalUnitsDisabled: true }));
      return true;
    } else {
      this.appState$.dispatch(openDialog({ dialogData: this.singleLocalUnitDialog() }));
      return false;
    }
  }

  private singleLocalUnitDialog = () => ({
    title: 'SHARED.DIALOG.ALERT_TITLE',
    message: ['SHARED.DIALOG.ONLY_ONE_UNIT'],
    buttons: [
      {
        label: 'SHARED.BUTTON.GOT_IT',
        icon: '',
        callback: () => {
          this.appState$.dispatch(closeDialog());
          this.appState$.dispatch(routingActions.navigateTo(this.routingLog[this.routingLog.length - 2]));
        }
      }
    ]
  })
}

